import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpComponentCategoryComponent from './adpComponentCategory.component';

let adpComponentCategoryModule = angular.module('adpComponentCategory', [
  uiRouter
])

.component('adpComponentCategory', adpComponentCategoryComponent)

.name;

export default adpComponentCategoryModule;



// WEBPACK FOOTER //
// ./src/app/components/adpComponentCategory/adpComponentCategory.js